export default __webpack_public_path__ + "static/media/2-4-4.659ab436.jpg";